import React, { useEffect, useState } from 'react';
import BOM from "@system/config/bom";
import { useBOMStore } from "src/hooks/bom";
import $ from "jquery";
import System from "../../../helper/system";
import Helper from "../../../helper/Helper";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import AxiosIndicatorRunTimeLoader from "../../../component/Global/AxiosIndicatorRunTimeLoader";
import { useProductFilterStore } from 'src/hooks/productFilter';

const FindPartPopup = ({ data, SetStatus }) => {
    const [__check] = useAxiosIndicatorCheck();
    const [displayProductCategoryList, setDisplayProductCategoryList] = useState([]);
    const [{ }, { fetch_product_category_list }, { create_blank_bom }] = useBOMStore();
    const bomId = System.getParams().bomId;
    const [searchData, setSearchData] = useState('');
    const [subProductCategoryList, setSubProductCategoryList] = useState([]);
    const addFrom = data?.addFrom;
    const [{ }, { }, { apply_product_filter }, { }] = useProductFilterStore();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const fetchProductCategories = async () => {
            const categories = await fetch_product_category_list();
            setDisplayProductCategoryList(categories);
        };
        fetchProductCategories();
    }, [SetStatus]);

    const onHide = () => {
        SetStatus(false)
        setLoader(false)
    }


    const handleCategorySelection = async (selectedCategory) => {
        const params = { ...System.getParams(), go: '' };
        history.pushState(null, null, '?' + $.param(params));
        setSearchData(selectedCategory.Name);

        if (selectedCategory.Categories) {
            setSubProductCategoryList(selectedCategory.Categories);
        } else if (selectedCategory.value) {
            setLoader(true)
            const filter = {
                key: "Categories",
                main_label: "Categories",
                value: selectedCategory.value.replace("'","''"),
                hidden_payload: selectedCategory.level ? {
                    Level: selectedCategory.level,
                    partNumber: validateNoMatch() ? data.manufacturerPartNumber : ''
                } : undefined
            };

            if (bomId || localStorage.getItem(System.storageName.GUEST_BOM_ID)) {
                apply_product_filter(filter);
                window.location.href = BOM.getBomProductListingRouteURL(bomId || localStorage.getItem(System.storageName.GUEST_BOM_ID), {
                    go: System.getParams().go,
                    addFrom,
                    ...data
                });
            } else {
                const newBom = await create_blank_bom();
                if (newBom?.data) {
                    apply_product_filter(filter);
                    window.location.href = BOM.getBomProductListingRouteURL(newBom.data, {
                        redirect_back_url: location.href,
                        addFrom,
                        go: System.getParams().go
                    });
                }
            }
        }
    };

    const resetState = () => {
        setSubProductCategoryList([]);
        setSearchData('');
    };

    const validateNoMatch = () => (
        !__check(['BOM_PRODUCT_CATEGORY_API_CALL']).status &&
        data?.no_match &&
        data.manufacturerPartNumber?.trim() !== ''
    );

    return (
        <div className="avnet-modal avnet-modal-right find-parts">
            <div className="avnet-modal-inner">
                <button type="button" className="close py-2" data-dismiss="modal" onClick={onHide}>×</button>
                <div className="modal-header">
                    <h4 className="modal-title text-center">FIND A PART</h4>
                    {(__check(['BOM_PRODUCT_CATEGORY_API_CALL']).status || loader) && <AxiosIndicatorRunTimeLoader />}
                </div>
                <div className="modal-body">
                    {data?.no_match && <div className="alert alert-info m-b-30"><span> You searched for {data.manufacturerPartNumber}, Find a Part starts with selecting a category</span></div>}
                    {!loader &&
                        <>
                            {!subProductCategoryList.length ? (
                                <ul>
                                    <h3 className='mt-0 mb-3'>Categories</h3>
                                    {displayProductCategoryList?.Categories?.map((category) => (
                                        <li className="mb-2" key={category.Name}>
                                            <a href={void (0)} onClick={() => handleCategorySelection(category)} className="text-blue2 font-bold font-arial font-13">
                                                {category.Name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <>
                                    <a className="me-3 mb-1 d-block text-blue2 font-arial font-14" href={void (0)} onClick={resetState}>
                                        <i className="fa fa-angle-double-left me-2" aria-hidden="true" />
                                        <strong>Back</strong>
                                    </a>
                                    <h3 className='mb-3'>Sub-Categories</h3>
                                    <h5 className='m-b-10 font-arial font-16'><strong>{searchData}</strong></h5>
                                    <ul className="ms-2">
                                        {subProductCategoryList.map((category) => (
                                            <li key={Helper.UUID()} className="mb-2">
                                                <a href={void (0)} onClick={() => handleCategorySelection(category)} className="text-blue2 font-bold font-arial font-13">
                                                    {category.Name}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </>
                            )}
                        </>
                    }
                </div>
            </div>
        </div>
    );
};

export default FindPartPopup;